import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Row, Col, Card, Spinner, Alert, Modal, Button } from '@themesberg/react-bootstrap';
import { get } from '../../services/back.service';

const ImagesReportGallery = () => {
  const { uuid } = useParams();
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const fetchImages = async () => {
      setLoading(true);
      setError(null);
      const res = await get(`/peritaje/images_report/${uuid}`, {});
      console.log('res', res)
      if (res.success) {
        setImages(res.data);
      } else {
        setError(res.message || 'Error al cargar las imágenes');
      }
      setLoading(false);
    };
    if (uuid) fetchImages();
  }, [uuid]);

  return (
    <Container className="my-4">
      <h2 className="fw-bold mb-4">Galería de Imágenes</h2>
      {loading && (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 200 }}>
          <Spinner animation="border" variant="primary" />
        </div>
      )}
      {error && (
        <Alert variant="danger">{error}</Alert>
      )}
      {!loading && !error && images.length === 0 && (
        <Alert variant="info">No hay imágenes para mostrar.</Alert>
      )}
      <Row>
        {images.map((img, idx) => (
          <Col key={idx} xs={12} sm={6} md={4} lg={3} className="mb-4">
            <Card className="h-100 shadow-sm" style={{ cursor: 'pointer' }} onClick={() => { setSelectedImage(img); setShowModal(true); }}>
              <Card.Img variant="top" src={img.base64} alt={img.name} style={{ objectFit: 'cover', height: 200 }} />
              <Card.Body>
                <Card.Text className="text-truncate" title={img.name}>{img.name}</Card.Text>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
      <Modal show={showModal} onHide={() => setShowModal(false)} centered size="xl">
        <Modal.Header closeButton>
          <Modal.Title>{selectedImage?.name}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
          {selectedImage && (
            <img
              src={selectedImage.base64}
              alt={selectedImage.name}
              style={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default ImagesReportGallery;
